import { combineReducers } from 'redux';
import login from './login/reducer';
import packageReducer from './package/reducer'
import bookingActivity from './bookingActivity/reducer';
import students from "./students/reducer";
import staffs from "./staffs/reducer";
import invoiceReducer from "./invoice/reducer";
import calendarReducer from "./calendar/reducer";
import parentReducer from "./parent/reducer";
import settingReducer from "./setting/reducer";
import notificationReducer from "./notification/reducer";
import dashboardReducer from "./dashboard/reducer";
import multicenterReducer from "./multicenter/reducer";
import accountReducer from "./accounts/reducer";
import userReducer from "./users/reducer";
import reportsReducer from './reports/reducer';
import accountLoginReducer from "./accountLogin/reducer";
import accountPackageReducer from "./accountPackage/reducer";
import paymentReducer from "./payment/reducer";
import activityReducer from "./activity/reducer";
import attendanceReducer from './attendance/reducer';
import rolesReducer from "./roles/reducer";
import godModeReducer from "./godMode/reducer";

const rootReducer = combineReducers({
    login,
    packageReducer,
    bookingActivity,
    students,
    staffs,
    invoiceReducer,
    calendarReducer,
    parentReducer,
    settingReducer,
    notificationReducer,
    dashboardReducer,
    multicenterReducer,
    accountReducer,
    userReducer,
    reportsReducer,
    accountLoginReducer,
    accountPackageReducer,
    paymentReducer,
    attendanceReducer,
    activityReducer,
    roles: rolesReducer,
    godMode: godModeReducer
});


export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;